import { SearchInput, ReferenceInput, SelectInput } from "react-admin";
import QuickFilter from "../ui/quick-filter";

const CustomFilterEnterpriseAdmin = [
  <SearchInput source="q" alwaysOn />,
  <ReferenceInput label="Empresa" source="enterprise_id" reference="setup/enterprises" alwaysOn >
    <SelectInput label="Empresa" optionText="name" optionValue="id" />
  </ReferenceInput>,
  <QuickFilter source="activated" label="Ativos" defaultValue={true} />,
  <QuickFilter source="disabled" label="Desativados" defaultValue={true} />
];

export default CustomFilterEnterpriseAdmin;
